module.exports = {
    error: 'error',
    idle: 'idle',
    loading: 'loading',
    success: 'success',
    fail: 'fail',
};
